import defineComponent from 'flight';

function PreventDefault() {
    this.defaultAttrs({
        preventDefault: '[data-prevent-default]'
    });

    this._preventDefaultClick = function(evt) {
        evt.preventDefault();
    };

    this.after('initialize', function() {
        this.on('click', {
            preventDefault: this._preventDefaultClick
        });
    });
}
export default defineComponent.component(PreventDefault);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/prevent-default.js